import angular from "angular"
import "front-end-web-commons"
import "../../bower_components/front-end-web-commons/app/filter/filter"

export default angular.module("jobModule", ["nlgTableModule", "nlgTableDynamicColumnsModule", "nlgPaginationModule", "filterModule", "remoteModule", "violationModule"])